import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import {
  AnalysisInfoFieldsFragment,
  PopulateBuilderAnalysisFieldsFragment,
} from './fragments';

export const CHANGE_ANALYSIS_INFO = gql`
  mutation analysisInfo($input: AnalysisInfoInput!) {
    analysisInfo(input: $input) {
      entity
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const SET_ANALYSIS_PREF = gql`
  mutation analysisSetPref($input: AnalysisSetPrefInput!) {
    analysisSetChartPref(input: $input) {
      entity
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const ANALYSIS_SET_SUMMARY_RICH_TEXT = gql`
  mutation analysisSetSummaryRichText(
    $input: AnalysisSetSummaryRichTextInput!
  ) {
    analysisSetSummaryRichText(input: $input) {
      entity
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const ANALYSIS_DELETE_SUMMARY_RICH_TEXT = gql`
  mutation analysisDeleteSummaryRichText(
    $input: AnalysisDeleteSummaryRichTextInput!
  ) {
    analysisDeleteSummaryRichText(input: $input) {
      entity
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const ANALYSIS_SET_SHOW_SUMMARY_IN_DASHBOARD = gql`
  mutation analysisSetShowSummaryInDashboard(
    $input: AnalysisSetShowSummaryInDashboardInput!
  ) {
    analysisSetShowSummaryInDashboard(input: $input) {
      entity
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const ANALYSIS_PREPARE_COHORT = gql`
  mutation analysisPrepareCohort($input: AnalysisPrepareCohortInput!) {
    analysisPrepareCohort(input: $input) {
      entity {
        analysis {
          ...AnalysisInfoFields
        }
        expressionMeasure {
          ... on SimpleMeasure {
            id
          }
          ... on CompoundMeasure {
            id
          }
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisInfoFieldsFragment}
  ${ErrorFragment}
`;

export const ANALYSIS_CUSTOMIZE = gql`
  mutation analysisCustomize($input: AnalysisCustomizeInput!) {
    analysisCustomize(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...PopulateBuilderAnalysisFields
      }
    }
  }
  ${ErrorFragment}
  ${PopulateBuilderAnalysisFieldsFragment}
`;

export const ANALYSIS_COPY = gql`
  mutation analysisCopy($input: AnalysisCopyInput!) {
    analysisCopy(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...PopulateBuilderAnalysisFields
      }
    }
  }
  ${ErrorFragment}
  ${PopulateBuilderAnalysisFieldsFragment}
`;

export const CANCEL_EXECUTION = gql`
  mutation cancelExecution($input: AnalysisCancelInput!) {
    analysisCancel(input: $input) {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;
